var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 144,
    viewBox: "0 0 154 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.515 25.8765C117.916 25.8765 120.831 33.6822 110.598 43.4002C100.365 53.1183 80.955 60.9434 66.5739 60.9434H55.6168L38.6725 77.0231C33.1548 77.0231 30.259 75.1497 30.259 72.2811C30.259 70.3297 31.57 67.9295 34.3092 65.3341L75.8678 25.8765H103.515H103.515ZM93.9078 43.4002C97.8406 39.673 97.0775 36.824 91.9708 36.824H81.0137L67.1609 49.9765H78.1179C83.2247 49.9765 89.975 47.1274 93.9078 43.4002L93.9078 43.4002Z",
    fill: "#DA0D29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1254 82.4089C0.518455 63.3046 22.0217 33.1357 58.18 15.0461C94.3187 -3.0435 131.436 -2.22392 141.062 16.8999",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.475 30.3842C131.964 45.6247 115.333 65.3925 89.9554 78.0182C64.6172 90.6243 38.6529 92.0293 26.6001 82.5259C24.4674 80.8477 22.7651 78.8378 21.5912 76.4961C13.6473 60.8262 31.3938 36.1213 61.2127 21.2906C91.0511 6.47935 121.653 7.14283 129.596 22.8127C130.79 25.1544 131.397 27.7107 131.475 30.3842H131.475Z",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.405 111.778C27.5394 109.455 21.5717 105.182 18.4802 99.0154L10.1255 82.4089C11.5538 85.2774 13.6083 87.7167 16.191 89.7657C18.8716 91.8927 22.1391 93.5709 25.8371 94.8003C30.5526 96.3615 36.0311 97.2006 42.0184 97.2981C46.4795 97.3762 51.2536 97.0445 56.2038 96.2834C60.4693 95.659 64.8716 94.7028 69.3719 93.4539C73.4416 92.322 77.5897 90.917 81.7768 89.2778C85.514 87.8143 89.2707 86.1361 93.0078 84.2627C93.1839 84.1651 93.3796 84.0871 93.5557 83.9895C97.4689 81.9991 101.206 79.8915 104.748 77.6474C108.504 75.2862 112.046 72.8079 115.333 70.2125C118.933 67.4025 122.24 64.4754 125.194 61.4897C128.618 58.0943 131.592 54.6012 134.097 51.1082C137.325 46.6199 139.771 42.0927 141.317 37.702C142.745 33.7016 143.449 29.8183 143.332 26.1301C143.234 22.8712 142.51 19.749 141.062 16.8999L149.398 33.4869C152.313 39.2631 152.372 46.0345 150.063 53.1767C148.615 57.6649 146.228 62.2898 142.999 66.9146C140.534 70.4662 137.58 73.9982 134.195 77.4718C131.24 80.4769 127.953 83.4236 124.372 86.2922C121.105 88.8875 117.583 91.4049 113.826 93.8051C110.304 96.0492 106.587 98.1958 102.674 100.186C102.243 100.42 101.813 100.655 101.363 100.869C97.8798 102.606 94.397 104.167 90.9338 105.553C86.7662 107.231 82.6378 108.655 78.568 109.826C74.0873 111.095 69.7045 112.09 65.4587 112.753C60.5475 113.553 55.8125 113.944 51.371 113.924C45.5012 113.905 40.1009 113.202 35.405 111.797",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.837 94.8004L35.4049 111.778V111.797",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3709 113.924L42.0183 97.2982",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4585 112.753L56.2037 96.2834",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5679 109.826L69.3718 93.4539",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9337 105.553L81.7767 89.2778",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.673 100.186L93.5555 83.9895",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.826 93.7856L104.747 77.6474",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.372 86.2922L115.333 70.2126",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.175 77.4523L125.194 61.4898",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.999 66.9146L134.097 51.1082",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.043 53.1767L141.317 37.702",
    stroke: "#2B363B",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.37 118.725C126.681 118.237 127.875 117.437 128.872 116.481C131.044 114.354 132.355 111.504 133.314 108.616C135.095 103.269 135.818 97.3176 133.705 92.0879",
    stroke: "#DA0D29",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.37 118.725C125.351 117.339 125.096 115.915 124.411 114.705C123.629 113.319 122.279 112.227 120.713 112.051C119.129 111.875 117.446 112.812 116.976 114.315C116.331 116.461 118.385 118.627 120.576 119.154C122.181 119.544 123.844 119.349 125.37 118.725V118.725Z",
    stroke: "#DA0D29",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.287 141.576C113.102 138.707 116.957 135.819 120.029 132.189C123.081 128.54 125.351 124.013 125.39 119.252C125.39 119.076 125.39 118.9 125.37 118.725",
    stroke: "#DA0D29",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30127 53.9814C6.16612 44.6798 11.694 36.0683 18.5465 28.6743",
    stroke: "#DA0D29",
    strokeWidth: 3.59854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.97d80d1b9ec6aac210f9045e6acc1834.svg";
export { ForwardRef as ReactComponent };